"use strict";
// ─── Inline types (mirrors @moment-golf/types) ───────────────────────────────
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveSeriesPoints = resolveSeriesPoints;
exports.applySeriesPointsToRows = applySeriesPointsToRows;
// ─── Core lookup ─────────────────────────────────────────────────────────────
/**
 * Resolves the series points for a given rank and optional division.
 * Falls back to global points (with scale 1) when no division override is found.
 * Returns 0 when the rank is outside all configured ranges (WD, DQ, not yet ranked).
 */
function resolveSeriesPoints(rank, division, seriesPoints) {
    if (!rank || rank <= 0)
        return 0;
    const rangeIdx = seriesPoints.ranges.findIndex((r) => rank >= r.startPlace && rank <= (r.endPlace ?? r.startPlace));
    if (rangeIdx === -1)
        return 0;
    const basePoints = seriesPoints.ranges[rangeIdx].points;
    const divEntry = division
        ? seriesPoints.divisionPoints.find((d) => d.division === division)
        : undefined;
    if (!divEntry || divEntry.mode === 'global-scaled') {
        const scale = divEntry?.scale ?? 1;
        return Math.round(basePoints * scale);
    }
    // mode === 'custom'
    return divEntry.customPoints[rangeIdx] ?? 0;
}
// ─── Row annotation ───────────────────────────────────────────────────────────
/**
 * Annotates each row in a ranked array with `seriesPointsEarned`.
 *
 * @param rows         Array of ranked leaderboard/team rows.
 * @param seriesPoints The series points config from the EventGroup.
 * @param rankKey      Which rank field to use ('rank' for individual, 'teamRank' for teams).
 * @param getDivision  Optional callback to extract the division from a row.
 *                     Defaults to `row.playerInfo?.[0]?.division` (individual rows).
 *                     For team rows pass: `(row) => row.eventScores?.[0]?.playerInfo?.[0]?.division`
 */
function applySeriesPointsToRows(rows, seriesPoints, rankKey = 'rank', getDivision) {
    return rows.map((row) => ({
        ...row,
        seriesPointsEarned: resolveSeriesPoints(row[rankKey], getDivision ? getDivision(row) : (row.playerInfo?.[0]?.division ?? null), seriesPoints),
    }));
}
